import React, { useState, useEffect } from "react";
import _ from "lodash";

import { alertServerError } from "features/helpers/utils";
import { useDispatch } from "react-redux";
import { useFetchTags, useFetchUserList } from "features/metadesk/redux/hooks";
import CustomUnassignModal from "components/CustomModals/CustomUnassignModal";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import { useIntl } from "react-intl";

const UnassignTagsModal = ({ open, onClose, entityName, choose, uniqTags }) => {
  const { formatMessage } = useIntl();
  const [isAdding, setIsAdding] = useState(false);
  const [unassignTags, setUnassignTags] = useState([]);
  const { batchUnApplyUserTags } = useFetchUserList();
  const { tags } = useFetchTags();
  const dispatch = useDispatch();
  useEffect(async () => {
    setUnassignTags([]);
  }, [open]);

  const closeModal = (isRefresh) => {
    setUnassignTags([]);
    onClose(isRefresh);
  };

  function handleClickCheckbox(e, tag) {
    if (e.target.checked) {
      setUnassignTags([...unassignTags, tag._id]);
    } else {
      setUnassignTags(unassignTags.filter((id) => id !== tag._id));
    }
  }

  const dispatchSnackbar = useDispatchSnackbar();

  const handleUnAssign = async () => {
    try {
      setIsAdding(true);
      await batchUnApplyUserTags({
        entityName,
        uids: choose,
        tagIds: unassignTags,
        tagData: _.filter(tags[entityName], (tag) =>
          _.includes(unassignTags, tag._id)
        ),
      });
      dispatchSnackbar({
        message: formatMessage({
          id: "global.snackbar.success.batchUnassignTags",
        }),
        variant: "success",
      });
      closeModal(true);
    } catch (err) {
      dispatch(alertServerError(err));
    } finally {
      setIsAdding(false);
    }
  };

  return (
    <CustomUnassignModal
      open={open}
      unassignTags={unassignTags}
      isLoading={isAdding}
      tags={uniqTags}
      handleClose={() => closeModal(false)}
      handleClickCheckbox={handleClickCheckbox}
      handleUnAssign={handleUnAssign}
    />
  );
};

export default UnassignTagsModal;
